export default __webpack_public_path__ + "static/media/Group5159-1d62888b4b662af9142e3c385f423f32.8c0aa0da.svg";